import { ConfirmDialog } from '@/components/ui/ConfirmDialog'
import { companyEditConfirmPresentation } from "@/features/company/constants"
import type { UsePaymentsTabReturn } from '@/features/company/types'

export function PaymentsTabDialogs({
        showUpdateAllConfirm,
        savePropertyIndex,
        setSavePropertyIndex,
        showDeleteFileConfirm,
        setShowDeleteFileConfirm,
        validateAddressPayload,
        setValidateAddressPayload,
        cancelUpdateAllPropertyConfirm,
        handleUpdateAllProperty,
        handleSaveProperty,
        handleDeleteFile,
        applyValidationResult,
}: UsePaymentsTabReturn) {
    return (
        <>
            <ConfirmDialog
                isOpen={showUpdateAllConfirm}
                title="Save Changes to All Property?"
                message="Are you sure want to save changes?"
                primaryLabel="Save"
                onPrimary={handleUpdateAllProperty}
                secondaryLabel="Cancel"
                onSecondary={cancelUpdateAllPropertyConfirm}
                {...companyEditConfirmPresentation}
                overlayDataTestId="company-payments-save-all-properties-confirm-overlay"
                primaryButtonDataTestId="company-payments-save-all-properties-confirm-primary-button"
                secondaryButtonDataTestId="company-payments-save-all-properties-confirm-secondary-button"
                closeButtonDataTestId="company-payments-save-all-properties-confirm-close-button"
            />
            {savePropertyIndex !== null && (
                <ConfirmDialog
                    isOpen={true}
                    title="Save Changes to Property?"
                    message="You have made changes, Are you sure want to save changes?"
                    primaryLabel="Save"
                    onPrimary={() => handleSaveProperty(savePropertyIndex)}
                    secondaryLabel="Cancel"
                    onSecondary={() => setSavePropertyIndex(null)}
                    {...companyEditConfirmPresentation}
                    overlayDataTestId="company-payments-save-one-property-confirm-overlay"
                    primaryButtonDataTestId="company-payments-save-one-property-confirm-primary-button"
                    secondaryButtonDataTestId="company-payments-save-one-property-confirm-secondary-button"
                    closeButtonDataTestId="company-payments-save-one-property-confirm-close-button"
                />
            )}
            {showDeleteFileConfirm && (
                <ConfirmDialog
                    isOpen={true}
                    title="Remove Document"
                    message="Please confirm that you really want to remove the file."
                    primaryLabel="Yes"
                    onPrimary={() =>
                        handleDeleteFile(showDeleteFileConfirm.fileId, showDeleteFileConfirm.type)
                    }
                    secondaryLabel="No"
                    onSecondary={() => setShowDeleteFileConfirm(null)}
                    {...companyEditConfirmPresentation}
                    overlayDataTestId="company-payments-remove-document-confirm-overlay"
                    primaryButtonDataTestId="company-payments-remove-document-confirm-yes-button"
                    secondaryButtonDataTestId="company-payments-remove-document-confirm-no-button"
                    closeButtonDataTestId="company-payments-remove-document-confirm-close-button"
                />
            )}
            {validateAddressPayload && (
                <ConfirmDialog
                    isOpen={true}
                    title={validateAddressPayload.verification === "1" ? "Valid Address" : "Verify Address"}
                    message={
                        validateAddressPayload.verification === "1"
                            ? validateAddressPayload.successMessage ??
                              "Address verified. Save to set Verified to Yes."
                            : "Warning: Unable to verify address. If you know this address is accurate or is not yet in Google Maps, you may verify the address manually and save the record."
                    }
                    primaryLabel="Yes"
                    onPrimary={() =>
                        applyValidationResult(
                            validateAddressPayload.verification,
                            validateAddressPayload.propertyIndex
                        )
                    }
                    secondaryLabel="No"
                    onSecondary={() => setValidateAddressPayload(null)}
                    {...companyEditConfirmPresentation}
                    overlayDataTestId="company-payments-verify-address-confirm-overlay"
                    primaryButtonDataTestId="company-payments-verify-address-confirm-yes-button"
                    secondaryButtonDataTestId="company-payments-verify-address-confirm-no-button"
                    closeButtonDataTestId="company-payments-verify-address-confirm-close-button"
                />
            )}
        </>
    )
}
